<div class="slider-container">
  <swiper #swiper [spaceBetween]="50" [slidesPerView]="1" [autoplay]="false" pagination>
    <ng-template swiperSlide *ngFor="let item of items; let i = index">
      <div class="slide-content">
        <div class="item animated fadeIn">
          <img class="main-image" [src]="item.imagen" alt="{{ item.texto }}" />
          <img class="mt-4 cont-icon" [src]="item.icon" alt="{{ item.texto }}" />
          <h3 class="mt-3">{{ item.subtitle }}</h3>
          <p class="mt-1">{{ item.texto }}</p>
          <button class="mt-3" (click)="i < items.length - 1 ? goToNextSlide(i + 1) : redirectToURL('login')">
            {{ item.button }}
          </button>
          <button *ngIf="item.button2" class="button2 mt-3 {{ item.display }}" (click)="redirectToURL('register')">
            {{ item.button2 }}
          </button>
        </div>
      </div>
    </ng-template>
  </swiper>
</div>
